import { render, staticRenderFns } from "./VenueInfoForm.vue?vue&type=template&id=d81143c4&scoped=true&"
import script from "./VenueInfoForm.vue?vue&type=script&lang=js&"
export * from "./VenueInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./VenueInfoForm.vue?vue&type=style&index=0&id=d81143c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81143c4",
  null
  
)

export default component.exports